export const GET_ADMIN = 'admin';
export const GET_USERS = 'users';
export const GET_USER = 'user';
export const GET_CATEGORIES = 'categories';
export const GET_CATEGORY = 'category';
export const GET_TEACHERS = 'teachers';
export const GET_TEACHER = 'teacher';
export const GET_ADMINISTRATORS = 'administrators';
export const GET_ADMINISTRATOR = 'administrator';
export const GET_COURSE = 'course';
export const GET_COURSES = 'courses';
export const GET_LESSONS = 'lessons';
export const GET_INVOICES = 'invoices';
export const GET_PAYMENTS = 'payments';
export const GET_PAYMENT = 'payment';
export const GET_HUBSPOT_CONTACTS = 'hubspotContacts';
export const GET_FINANCE_SUMMARY = 'financeSummary';
export const GET_FINANCE_HEALTH = 'financeHealth';
export const GET_FINANCE_REPORTS = 'financeReports';
export const GET_BADGES_LEADERBOARD = 'badgesLeaderboard';
export const GET_BADGES = 'badges';
export const GET_BADGE_RECIPIENTS = 'badgeRecipients';
export const GET_HOMEWORKS = 'homeworks';
export const GET_NOTIFICATIONS = 'notifications';
export const GET_MY_NOTIFICATIONS = 'myNotifications';
export const GET_MY_NOTIFICATIONS_UNREAD_COUNT = 'myNotificationsUnreadCount';
export const GET_EMAIL_NOTIFICATIONS = 'emailNotifications';
export const GET_HOMEWORK = 'homework';
export const GET_EVENTS = 'events';
export const GET_EVENT = 'event';
export const GET_REVIEWS = 'reviews';
export const GET_REVIEW = 'review';
export const GET_DASHBOARD = 'dashboard';
export const GET_STUDENTS = 'students';
export const GET_STUDENT = 'student';
export const GET_USER_NOTES = 'userNotes';
export const GET_APPLICANTS = 'applicants';
export const GET_USER_ACTIVITIES = 'userActivities';
export const GET_APPLICATIONS = 'applications';
export const GET_APPLICATIONS_COUNT = 'applicationsCount';
export const GET_APPLICATION = 'application';
export const GET_ACADEMIC_STAFF = 'academicStaff';
export const GET_ASSIGNMENTS = 'assignments';
export const GET_CERTIFICATES_COURSES = 'certificatesCourses';
export const GET_CERTIFICATES_BY_COURSE = 'certificatesByCourse';
export const GET_CERTIFICATES_SIGNATURE = 'certificatesSignature';
export const GET_ADMIN_ROLES = 'adminRoles';
export const GET_ADMIN_ROLE_STAFF = 'adminRoleStaff';
export const GET_ADMIN_DEPARTMENTS = 'adminDepartments';
export const GET_MY_ADMIN_ACCESS = 'myAdminAccess';
export const GET_LOCATIONS = 'locations';
export const GET_TAGS = 'tags';
export const GET_REPORTS = 'reports';
export const GET_CALENDAR = 'calendar';
export const GET_ATTENDANCE = 'attendance';
export const GET_NEWS = 'news';
export const GET_BLOGS = 'blogs';
export const GET_ACCOUNT_DELETIONS = 'accountDeletions';
